:host{--h3-subpoint-display: initial}
/*# sourceMappingURL=keypoint-shape.component.css.map */
